export const INITIAL_STATE = {
    themeName: '',
    backgroundImageUrl: '',
    thumbnailImageUrl: '',
    frontImageUrl: '',
    backImageUrl: '',
    mobileImageUrl: '',

    emailSubject: '',
    emailMessage: '',
    smsMessage: '',

    templates: null,

    loading: false,
    error: '',
    success: false,
    validated: false,
    categories: [],
    selectedCategoryId: '',
};


export const SUCCESS_MESSAGE = 'VOUCHER_THEME_ADDED_SUCCESSFULLY';

export const TOAST_MESSAGES = {
    success: 'Voucher theme created successfully!',
    error: 'Failed to create voucher theme. Please try again.',
    categoryError: 'Failed to fetch categories',
};

export const VALIDATION_ERROR_MESSAGES = {
    themeName: 'Please provide a theme name.',
    frontImageUrl: 'Front image URL is required',
    backImageUrl: 'Back image URL is required',
    mobileImageUrl: 'Mobile image URL is required',
    emailSubject: 'Email subject is required',
    emailMessage: 'Email message is required',
    smsMessage: 'SMS message is required',
};

// Validate URL field - must start with https://
const validateUrlField = (url) => {
    if (!url || url.trim() === '') {
        return null; // Empty URLs are handled by required field validation
    }
    if (!url.startsWith('https://')) {
        return 'URL must start with https://';
    }
    return null; // Valid URL
};

// Validate form data and return an errors object keyed by field name
// Validates required fields and URL formats
export const validateForm = (formData = {}) => {
    const errs = {};
    const imageUrlFields = ['frontImageUrl', 'backImageUrl', 'mobileImageUrl', 'thumbnailImageUrl', 'backgroundImageUrl'];

    // Validate only required fields defined in constants
    VOUCHER_THEME_FORM_FIELDS.forEach(field => {
        if (field.required) {
            const val = formData[field.name];
            const empty = val === null || typeof val === 'undefined' || String(val).trim() === '';
            if (empty) {
                errs[field.name] = field.validationMessage || `${field.label} is required`;
            }
        }
    });

    // Validate URL format for image URL fields
    imageUrlFields.forEach(fieldName => {
        const urlValue = formData[fieldName];
        if (urlValue && urlValue.trim() !== '') {
            const urlError = validateUrlField(urlValue);
            if (urlError) {
                errs[fieldName] = urlError;
            }
        }
    });

    return errs;
};

export const VOUCHER_THEME_FORM_FIELDS = [
    {
        name: 'themeName',
        label: 'Theme Name',
        type: 'text',
        placeholder: 'Enter theme name',
        required: true,
        validationMessage: 'Please provide a theme name.',
        maxLength: 50,
    },
    {
        name: 'frontImageUrl',
        label: 'Front Image URL',
        type: 'text',
        placeholder: 'https://example.com/front_image.png',
        required: true,
        validationMessage: 'Front image URL is required',
        maxLength: 200,
    },
    {
        name: 'backImageUrl',
        label: 'Back Image URL',
        type: 'text',
        placeholder: 'https://example.com/back_image.png',
        required: true,
        validationMessage: 'Back image URL is required',
        maxLength: 200,
    },
    {
        name: 'mobileImageUrl',
        label: 'Mobile Image URL',
        type: 'text',
        placeholder: 'https://example.com/mobile_image.png',
        required: true,
        validationMessage: 'Mobile image URL is required',
        maxLength: 200,
    },
    {
        name: 'thumbnailImageUrl',
        label: 'Thumbnail Image URL',
        type: 'text',
        placeholder: 'https://example.com/thumbnail_image.png',
        required: true,
        maxLength: 200,
    },
    {
        name: 'backgroundImageUrl',
        label: 'Background Image URL',
        type: 'text',
        placeholder: 'https://example.com/background_image.png',
        required: true,
        maxLength: 200,
    },
    {
        name: 'emailSubject',
        label: 'Email Subject',
        type: 'text',
        placeholder: 'Enter email subject',
        required: true,
        validationMessage: 'Email subject is required',
    },
    {
        name: 'emailMessage',
        label: 'Email Message',
        type: 'textarea',
        placeholder: 'Enter email message',
        required: true,
        validationMessage: 'Email message is required',
        rows: 12,
    },
    {
        name: 'smsMessage',
        label: 'SMS Message',
        type: 'textarea',
        placeholder: 'Enter SMS message',
        required: true,
        validationMessage: 'SMS message is required',
        rows: 4,
    },
];